module.exports = __webpack_public_path__ + "static/media/klart-t.551f07fb.mp3";